//=require /static/src/static/js/core/jquery.js
//=require /static/src/static/js/core/jquery-migrate.js
//=require /static/src/static/js/plugins/jquery.prettyPhoto.js
//=require /static/src/static/js/plugins/video-lightbox.js
//=require /static/src/static/js/vendor/jquery-ui.js
//=require /static/src/static/js/vendor/what-input.js
//=require /static/src/static/js/vendor/foundation.min.js
//=require /static/src/static/js/vendor/hammer.min.js
//=require /static/src/static/js/custom/app.js
//=require /static/src/static/js/custom/header.js
//=require /static/src/static/js/custom/appLink.js
//=require /static/src/static/js/vendor/splide.min.js
//=require /static/src/static/js/vendor/slick.min.js
//=require /static/src/static/js/custom/customerReviews.js
//=require /static/src/static/js/custom/fullwidth_slider.js
//=require /static/src/static/js/custom/gallery_and_copy_generic_modal.js
//=require /static/src/static/js/custom/gallery_slider.js
//=require /static/src/static/js/custom/diningMenu.js
//=require /static/src/static/js/custom/bookDirectly.js
//=require /static/src/static/js/custom/media-gallery.js
//=require /static/src/static/js/custom/subscribe-form.js
//=require /static/src/static/js/plugins/clickable.js
//=require /static/src/static/js/custom/theater-map.js
//=require /static/src/static/js/custom/home-page-island-experiences.js
//=require /static/src/static/js/custom/home-page-expand.js
//=require /static/src/static/js/custom/island_tour_modal.js

(function ($) {
    "use strict";

    $(function() {
        
        // Accordion expand/collapse all link
        const accordion = $('.accordion-block');
        let currentHashID = null;

        accordion.each(function() {
            const $parent = $(this);
            const $accordion = $parent.find('.accordion');
            const expandAll = $parent.find('.accordion__expand-all');
            const items = $parent.find('.accordion-item');

            items.each(function() {
                $(this).find('.accordion-title').on('click', function() {
                    if ($(this).attr('aria-expanded') === 'true') {
                        currentHashID = $(this).attr('href');
                    } else {
                        if ($accordion.find('.accordion-title[aria-expanded="true"]').length) {
                            currentHashID = $accordion.find('.accordion-title[aria-expanded="true"]').attr('href');
                        } else {
                            currentHashID = null;
                        }
                    }
                });
            });
    
            // Expand/Collapse all button
            expandAll.on('click', function(event) {
                event.preventDefault();
                const $this = $(this);
                const state = ($this.attr('aria-expanded') === 'true') ? 'false' : 'true';
                
                $this.attr('aria-expanded', state);

                if (state === 'true') {
                    $accordion.foundation('down', $accordion.find('.accordion-content'));
                    $parent.find('.accordion-title[aria-expanded="false"]').attr('aria-expanded', 'true');
                } else {
                    $accordion.foundation('up', $accordion.find('.accordion-content'));
                    $parent.find('.accordion-title[aria-expanded="true"]').attr('aria-expanded', 'false');
                }

                urlHashUpdater(null);
            });

            $accordion.on('down.zf.accordion', function() {
                expandAll.attr('aria-expanded', 'true');
                urlHashUpdater(currentHashID);
            });

            $accordion.on('up.zf.accordion', function() {
                if ($parent.find('.accordion-title[aria-expanded="true"]').length === 0) {
                    expandAll.attr('aria-expanded', 'false');
                }
                urlHashUpdater(currentHashID);
            });

            const backToTop = $parent.find('.accordion__to-top');
            backToTop.on('click', function(event) {
                event.preventDefault();
                $parent[0].scrollIntoView();
            });
        });

        const hash = window.location.hash;
        let hashEl = null;

        if (hash) {
            hashEl = document.querySelectorAll(`[href="${hash}"], ${hash}`)[0];
        }
        
        if (hashEl) {
            if (hashEl.closest('.accordion-item')) {
                instantOpenerProMax($(hashEl));
                hashEl.closest('.accordion-item').scrollIntoView();
            }
        }

        function instantOpenerProMax(target) {
            const accordionTarget = $(target);
            const accordionParent = accordionTarget.closest('.accordion-item');
            const accordionTitle = accordionParent.find('.accordion-title');
            const accordionContent = accordionParent.find('.accordion-content');
            const expandAll  = $(target).closest('.accordion-block__main').find('.accordion__expand-all');

            accordionParent.addClass('is-active');

            accordionTitle.attr('aria-expanded', 'true');

            accordionContent
                .attr('aria-hidden', 'false')
                .css('display', 'block');

            expandAll.attr('aria-expanded', 'true');
        }

        function urlHashUpdater(hash) {
            if (hash && hash.length > 1) {
                window.history.replaceState({}, '', `${window.location.pathname}${hash}`);
            } else {
                const originalURL = location.origin + location.pathname;
                window.history.replaceState({}, '', originalURL);
            }
        }

        $('[data-open]').on('click', (e) => {
            e.preventDefault();
        });

        /** 
            Since foundation reveal requires jquery, we'll wait for jquery
            to load before initializing the media gallery
        */

        $(window).on('load', () => {
            if ($('.media-gallery__item').length) {
                mediaGallery();
            }
        });

        // Alert banner close button
        var alertBanner = $('.alert-banner');
        
        alertBanner.each(function() {
            var $banner = $(this);
            var closeBtn = $banner.find('.alert-banner__close');

            closeBtn.on('click', function() {
                $banner.slideUp({
                    complete: function() {
                        $banner.hide();
                    }
                });
            });
        })

        // Load Hero video
        function loadHeroVideo() {
            if (window.matchMedia("(min-width: 640px)").matches) {
                $(".masthead__video-container video source").each(function () {
                    var videoSource = $(this).data("src");
                    $(this).attr("src", videoSource);

                    var video = this.parentElement;
                    video.load();
                    video.play();
                });
            }
        }

        $(document).ready(loadHeroVideo);
        $(window).on('resize', loadHeroVideo);
    });
})(jQuery);
